export const purposes = [
  { value: "friendship", label: "Дружба", description: "Общение без романтики" },
  { value: "love", label: "Любовь", description: "Найти человека для глубоких чувств и взаимной привязанности" },
  { value: "adventure", label: "Приключение", description: "Поиск новых, ярких впечатлений и нестандартного общения" },
] as const;
export const occupations = [
  "IT",
  "Автомобилестроение",
  "Аэрокосмос",
  "Банковское дело",
  "Биотехнологии",
  "Блогинг",
  "Бухгалтерия",
  "Гос. управление",
  "Гостиничный бизнес",
  "Здравоохранение",
  "Инженерия",
  "Искусство",
  "Медиа",
  "Мода",
  "Модельный бизнес",
  "Музыка",
  "Наука",
  "Образование",
  "Предпринимательство",
  "Реклама",
  "Спорт",
  "Строительство",
  "Торговля",
  "Транспорт",
  "Туризм",
  "Юриспруденция",
  "Другое",
];
export type ProfileDetails = {
  purpose: string | null;
  occupation: string | null;
  heightCm: number | null;
  station: string | null;
  socialUsername: string | null;
  locationId: string;
  hideAge?: boolean;
  hideOnline?: boolean;
};
export type SearchSettings = {
  interestedIn: Array<"female" | "male" | "other">;
  ageMin: number;
  ageMax: number;
  purpose: string | null;
  occupation: string | null;
  heightMin: number;
  heightMax: number;
  station: string | null;
  socialOnly: boolean;
  videoOnly?: boolean;
  autoExpandAge: boolean;
};
